module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/3864ca20f8165ca4050a42abd2ea1282.png";